<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    layout: WebLayout,
}
</script>

<script setup>
import LegalDocument from '@/components/LegalDocument.vue'
</script>

<template>
    <LegalDocument translation-key="terms" route-name="web.terms-conditions" />
</template>
